import { render, staticRenderFns } from "./TasksViewToolbarShell.vue?vue&type=template&id=06a6cd00"
import script from "./TasksViewToolbarShell.vue?vue&type=script&lang=js"
export * from "./TasksViewToolbarShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports